import { defineMessage } from 'services/localization';

export const messages = {
    xeroIntegrationDisplayName: defineMessage('xero'),
    qbooksIntegrationDisplayName: defineMessage('quickbooks_online'),
    netsuiteIntegrationDisplayName: defineMessage('oracle_netsuite'),
    dearIntegrationDisplayName: defineMessage('cin_core'),
};

export const xeroMessages = {
    errorText5003: defineMessage('connection_error_oauth__reconnect_to_xero_again'),
    errorText5004: defineMessage('connection_error_oauth__orized_please_reconnect'),
    errorText5006: defineMessage('connection_error_reques_reconnect_to_xero_again'),
    errorText5013: defineMessage('connection_error_xero_a_lease_retry_in_a_minute'),
    errorText5014: defineMessage('connection_error_oauth__reconnect_to_xero_again_1'),
    errorText5015: defineMessage('connection_error_genera_reconnect_to_xero_again'),
    errorText4050: defineMessage('connection_error_generic_error_during_integration'),
    errorTextGeneric: defineMessage('connection_error_generic_error_in_xero_connection'),
};

export const qbooksMessages = {
    errorTextGeneric: defineMessage('connection_error_generi_n_quickbooks_connection'),
};

export const dearMessages = {
    errorText7504: defineMessage('connection_error_invalid_login_attempt'),
    integrationGenericErrorText: defineMessage('connection_error_generi__in_cin_core_connection'),
};

export const netSuiteMessages = {
    errorText7504: defineMessage('connection_error_invalid_login_attempt'),
    integrationGenericErrorText: defineMessage('connection_error_generi_cle_netsuite_connection'),
};
